import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const testimonials = [
  {
    name: "Miss. Priya Patil",
    position: "Customer, Mauli Cabs",
    text: "Mauli Cabs offers an outstanding service! I felt safe, comfortable, and the ride was perfect. Highly recommended for anyone who needs a reliable ride.",
    image: "/img/testimonial/testimonial-thumb-1-1.png",
  },
  {
    name: "Mr. Rajesh Kumar",
    position: "Frequent Traveler, Mauli Cabs",
    text: "I have been using Mauli Cabs for all my travels and I can’t be happier. The drivers are always punctual, and the cars are top-notch in terms of comfort.",
    image: "/img/testimonial/testimonial-thumb-1-2.png",
  },
  {
    name: "Miss. Anjali Sharma",
    position: "Tourist, Mauli Cabs",
    text: "I had a fantastic experience with Mauli Cabs during my trip. The ride was smooth, and the driver was friendly and professional. I’ll definitely use their service again.",
    image: "/img/testimonial/testimonial-thumb-1-3.png",
  },
  {
    name: "Mr. Vikram Singh",
    position: "Business Traveler, Mauli Cabs",
    text: "Mauli Cabs offers premium services at an affordable price. The punctuality and the vehicle condition were excellent. I rely on them for all my corporate travel.",
    image: "/img/testimonial/testimonial-thumb-1-4.png",
  },
];

const TestimonialSection = () => {
  return (
    <section
      className="testimonial position-relative space"
      style={{
        backgroundImage: "url('/img/bg/testimonial-bg.png')",
        backgroundSize: "cover",
      }}
    >
      <img
        src="/img/icons/eiffel-tower-dark.png"
        alt="testimonial-icon"
        className="testimonial-icon"
      />
      <div className="container py-5">
        <div className="title-area text-center">
          <span className="sec-subtitle">Our Testimonials</span>
          <h2 className="sec-title">What Our Customers Say About Mauli Cabs</h2>
        </div>
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 4000 }}
          pagination={{ clickable: true }}
          loop={true}
          spaceBetween={30}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            },
          }}
          className="testimonial-slider mt-5"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-content text-center p-4 bg-white shadow rounded">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  style={{ width: 70, borderRadius: "50%", marginBottom: 20 }}
                />
                <i className="fa-solid fa-quote-left mb-2"></i>
                <div className="rating mb-2">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star text-warning mx-1"></i>
                  ))}
                </div>
                <p className="revew mx-auto" style={{ maxWidth: 500 }}>
                  “{testimonial.text}”
                </p>
                <div className="author mt-3">
                  <h5 className="author-name mb-1">{testimonial.name}</h5>
                  <span className="author-degi">{testimonial.position}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSection;
